import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "登录到云莓智能", -1);
import { reactive } from "vue";
import { YunmeiAPI } from "@/utils/yunmei";
import { useRouter } from "vue-router";
export default {
  __name: 'loginPage',
  setup(__props) {
    const router = useRouter();
    const input = reactive({
      userName: "",
      password: "",
      schoolNo: -1
    });
    const data = reactive({
      lockSelect: undefined,
      lockList: [],
      schoolList: [],
      loginStat: "登录"
    });
    const api = new YunmeiAPI();
    async function login() {
      try {
        await api.init(input.userName, input.password, false);
      } catch (e) {
        data.loginStat = "登录失败" + e.toString();
      }
      console.log(api.schools);
      data.schoolList = api.schools;
      input.schoolNo = "请选择学校";
    }
    async function schoolSelect() {
      api.setSchool(parseInt(input.schoolNo));
      data.lockSelect = "正在加载门锁";
      data.lockList = await api.loginAndGetLock();
      data.lockSelect = "请选择门锁";
    }
    function lockSelected() {
      router.push("/lock_info/" + data.lockSelect.toString(true));
    }
    return (_ctx, _cache) => {
      const _component_el_alert = _resolveComponent("el-alert");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createVNode(_component_el_alert, {
        title: "您的账号信息将经过我们的服务器。关于我们如何处理这些数据，请查看首页-关于",
        type: "warning"
      }), _createVNode(_component_el_input, {
        modelValue: input.userName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => input.userName = $event),
        placeholder: "云莓智能账号"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
        modelValue: input.password,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => input.password = $event),
        type: "password",
        placeholder: "云莓智能密码",
        "show-password": ""
      }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
        onClick: login
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(data.loginStat), 1)]),
        _: 1
      }), data.schoolList.length ? (_openBlock(), _createBlock(_component_el_select, {
        key: 0,
        onChange: schoolSelect,
        modelValue: input.schoolNo,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => input.schoolNo = $event),
        class: "m-2",
        placeholder: "选择学校",
        size: "large"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.schoolList, (item, index) => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.schoolNo,
            label: item.schoolName,
            value: index
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), data.schoolList.length ? (_openBlock(), _createBlock(_component_el_select, {
        key: 1,
        onChange: lockSelected,
        modelValue: data.lockSelect,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => data.lockSelect = $event),
        class: "m-2",
        placeholder: "选择锁",
        size: "large"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.lockList, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.label,
            label: item.label,
            value: item
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true)], 64);
    };
  }
};